// 导入React框架及状态管理工具
import React, { useState } from 'react'
import Sidebar from './Sidebar'
import EditSidebar from './EditSidebar'
import Header from './Header'
import { Outlet, useLocation } from 'react-router-dom'

const Layout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const location = useLocation()

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <div className="flex min-h-screen bg-gray-950 text-white">
      {/* 左侧 Sidebar 面板 - 固定不滚动 */}
      <div className="fixed top-0 left-0 h-screen flex-shrink-0 z-10">
        {/* 根据当前路由动态切换Sidebar和EditSidebar */}
        {location.pathname === '/production/video/edit' ? (
          <EditSidebar />
        ) : (
          <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
        )}
      </div>

      {/* 右侧内容面板 - 滚动条仅在此区域显示 */}
      <div className={`flex-1 flex flex-col ${location.pathname === '/production/video/edit' ? 'ml-14' : (sidebarCollapsed ? 'ml-14' : 'ml-[188px]')} transition-all duration-300`}>
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

      </div>
    </div>
  )
}

export default Layout